module.exports = __webpack_public_path__ + "img/1.3140b0e3.png";